import {useEffect, useState, useContext} from 'react';
import {Row, Col, Card, Button, Form, Modal} from 'react-bootstrap';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import Swal from 'sweetalert2';
import Select from 'react-select';
import {useHistory} from 'react-router-dom';
import axios from '../../../services/axios';
import moment from 'moment';
import {ConfigContext} from '../../../contexts/ConfigContext';
import {ESPIONAR_SEFAZ, TIPOCONSULTA, SEQPESQNFE, UPDATEDATAINI} from '../../../store/actions';
import procurando2 from '../../../assets/images/procurando3.gif';
import noData from '../../../assets/images/no-data.png';
import {TrataDataIniEmpresas, DownloadCloudMonitor} from '../../../components/Utilitarios/Funcoes';
import OpcoesNfe from './nfe/index';
import OpcoesCte from './cte/index';
import OpcoesNfse from './nfse';

import addDays from 'date-fns/addDays';

// BUG: Verificar sweetAlert para o response.data 'nao encontrou', pois não retorna nada para CT-e

/**
 *
 *
 * @param {*} props showModalEspionar | setShowModalEspionar
 * @return {*}
 */

const ModalEspionar = () => {
  const configContext = useContext(ConfigContext);
  const {state} = configContext;
  const {moduloAtual} = state;
  const {dispatch} = configContext;
  //Primeira consulta
  const [enablePesquisar, setEnablePesquisar] = useState(false); // Hablita o botao para consultar
  const [tipoDocCons, setTipoDocCons] = useState('-1'); //-1 = Nenhum, 0 = NFE, 1 = CTE, 2 = NFSE
  const [bgSelectNfe, setBgSelectNfe] = useState(''); // Background do card NFE
  const [bgSelecCte, setBgSelectCte] = useState(''); // Background do card CTE
  const [bgSelectNfse, setBgSelectNfse] = useState(''); // Background do card NFSE
  const [rbManif, setRbManif] = useState('0'); // 0 = Não manifestar, 1 = Ciência da Operação
  const [rbPeriodo, setRbPeriodo] = useState(90); // 90 = 90 dias, 60 = 60 dias, 30 = 30 dias
  const [rbPeriodoCte, setRbPeriodoCte] = useState(30); // 90 = 90 dias, 60 = 60 dias, 30 = 30 dias
  const [rbTomador, setRbTomador] = useState('0'); // 0 = Apenas Tomador, 1 = Todas as participações
  const [rbNsu, setRbNsu] = useState(0); // 0 = Último NSU, 1 = A partir do NSU
  const [rbNsuCte, setRbNsuCte] = useState(0); // 0 = Último NSU, 1 = A partir do NSU
  const [rbNsuNfse, setRbNsuNfse] = useState(0); // 0 = Último NSU, 1 = A partir do NSU
  const [selectEmpresa, setselectEmpresa] = useState([0]); //Options do SELECT empresas
  const [param, setParam] = useState({}); // Parâmetros de permissão

  const [empselecionada, setempselecionada] = useState({
    value: 0,
    label: 'Selecione uma empresa',
    cnpj_cpf: '',
    tipo: 0,
    espionar_nfe: 'f',
    espionar_cte: 'f',
    espionar_nfse: 'f',
    maior_nsu_nfe: 0,
    ultima_consulta_nfe: '',
    ultima_consulta_cte: '',
    ultima_consulta_nfse: '',
    opcao_consulta_cte: '0',
    inscricao_municipal: '',
    bloqueio_interno: false,
    anfe: '0',
    acte: '0',
    anfse: '0',
  }); // Empresa selecionada
  const [txtNsuValue, setTxtNsuValue] = useState(''); // NSU digitado
  const [txtNsuValueCte, setTxtNsuValueCte] = useState(''); // NSU digitado
  const [txtNsuValueNfse, setTxtNsuValueNfse] = useState(''); // NSU digitado
  const [tipoCertificado, setTipoCertificado] = useState(0); // 0 = A1, 1 = A3
  const [espionando, setEspionando] = useState(false); // Espionando
  const [primeiroLoad, setPrimeiroLoad] = useState(true); // Primeira vez que carrega
  const [rbNFSe, setRbNFSe] = useState(-1); // 0 = nacional 1 = municipal
  const [arrayPermiteEspionar, setArrayPermiteEspionar] = useState({nfe: 't', cte: 't', nfse: 't'}); // Array de empresas que permite espionar
  const [arrayPermiteEspionarConta, setArrayPermiteEspionarConta] = useState({nfe: 't', cte: 't', nfse: 't'}); // Array de empresas que permite espionar
  const [inscricaoMunicipal, setInscricaoMunicipal] = useState(''); // Inscrição municipal
  const [periodoNfse, setPeriodoNfse] = useState([new addDays(new Date(), -15), new Date()]); // Período de pesquisa NFSe
  const [tipoServico, setTipoServico] = useState({value: '1', label: 'Prestados', isDisabled: false}); // Tipo de serviço NFSe
  const sessiosS = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
  const uid = sessiosS[3];
  const planoAtual = sessiosS[8];

  const strg = localStorage.getItem(`xpaccss${base64_encode(uid)}`);
  const storageGeral = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
  const planoId = storageGeral[8];

  const arrStrg = JSON.parse(base64_decode(strg));
  const [showOptConsulta, setShowOptConsulta] = useState(true);

  const [selectedMunicipio, setSelectedMunicipio] = useState([{value: -1, label: 'Carregando Municípios disponíveis'}]);
  // const [selectedMunicipioByHistory, setSelectedMunicipioByHistory] = useState({}); // Selecionado por histórico
  const [dataHoraNfe, setDataHoraNfe] = useState(''); // data e hora da ultima consulta nfe
  const [dataHoraCte, setDataHoraCte] = useState(''); // data e hora da ultima consulta Cte
  const [dataHoraNfse, setDataHoraNfse] = useState(''); // data e hora da ultima consulta Nfse
  const [blqInterno, setBlqInterno] = useState(false); // Bloqueio interno
  const [possuiSaldo, setPossuiSaldo] = useState(false); // Possui saldo
  const [expandirDetalhesAuto, setExpandirDetalhesAuto] = useState(false); // Controla expansão dos detalhes da consulta automática
  const espionarA3 = [
    <Row>
      <Col
        sm={12}
        className='text-center'
      >
        <h5>Certificado A3 conectado ao computador</h5>
        <p className='mb-1'>Com certificado A3, as consultas não são automáticas. Elas precisam ser feitas manualmente pelo Espião Monitor.</p>
        <p className='mb-1'>Siga os passos abaixo no computador onde o cartão/pendrive A3 está conectado:</p>
        <ul className='text-left d-inline-block mb-2 small'>
          <li>Abra o aplicativo Espião Monitor no seu computador.</li>
          <li>Entre com os mesmos dados de acesso da sua conta.</li>
          <li>Selecione a empresa com certificado A3.</li>
          <li>Escolha o tipo de documento (NF-e ou CT-e) e o período desejado.</li>
          <li>Inicie a consulta manualmente pelo Espião Monitor.</li>
        </ul>
        <small className='d-block mb-2'>Para uma experiência melhor e consultas automáticas, recomendamos o uso do certificado A1.</small>
        <br />
        <Button
          variant='primary'
          className='rounded btn-sm mt-1 tour-2'
          onClick={() => DownloadCloudMonitor()}
        >
          Download Espião Monitor
        </Button>
      </Col>
    </Row>,
  ];

  const [paramEspionarNfe, setParamEspionarNfe] = useState(true);
  const [paramEspionarCte, setParamEspionarCte] = useState(true);
  const [paramEspionarNfse, setParamEspionarNfse] = useState(true);
  const [paramMunicipal, setParamMunicipal] = useState(true);

  let history = useHistory();
  localStorage.setItem('tipoTeste', 1);

  /* Ao mudar a empresa selecionada */
  const handleChangeEmpresa = (e) => {
    setempselecionada(e);

    if (e === undefined) return;
    if (e.tipo !== null && e.tipo !== undefined) {
      const tipoNum = parseInt(e.tipo);

      setTipoCertificado(tipoNum);

      // Reseta a seleção de documento ao mudar de empresa
      setTipoDocCons('-1');
      setBgSelectNfe('');
      setBgSelectCte('');
      setBgSelectNfse('');
    } else {
      setTipoCertificado(-1);
    }

    //Permissao da configuração da empresa
    //setArrayPermiteEspionar({ nfe: e.espionar_nfe, cte: e.espionar_cte, nfse: e.espionar_nfse });

    const EspionaNfeConta_ = e.espionar_nfe === 't' ? '1' : '0';
    const EspionaCteConta_ = e.espionar_cte === 't' ? '1' : '0';

    const EspionaNfseConta_ = e.espionar_nfse === 't' ? '1' : '0';

    const soma = parseInt(EspionaNfeConta_) + parseInt(EspionaCteConta_) + parseInt(EspionaNfseConta_);

    // if (soma > 0) setArrayPermiteEspionar({nfe: e.espionar_nfe, cte: e.espionar_cte, nfse: e.espionar_nfse});
    //

    verificaPermissao(e);
    setDataHoraNfe(e.ultima_consulta_nfe);
    setDataHoraNfse(e.ultima_consulta_nfse);
    setRbTomador(e.opcao_consulta_cte);
    setInscricaoMunicipal(e.inscricao_municipal);
    setBlqInterno(e.bloqueio_interno);
    setRbManif(e.opcao_consulta_nfe);

    if (e.ultima_consulta_cte_s === null) {
      setDataHoraCte(<span className='text-danger'>Nunca consultado</span>);
    } else {
      setDataHoraCte(e.ultima_consulta_cte_s);
    }

    localStorage.setItem('empDoc', base64_encode(JSON.stringify(e)));
  };
  const handleTipoDoc = (e) => {
    const tipoSelecionado = e.target.value;

    // Planos 1 e 4 não podem selecionar NFS-e (Nacional nem Prefeituras)
    if (['2', '3', '4'].includes(tipoSelecionado) && ['1', '4'].includes(String(planoAtual))) {
      Swal.fire({
        icon: 'info',
        title: 'Recurso indisponível no seu plano',
        html: '<p>A consulta de <strong>NFS-e</strong> (Nacional e Prefeituras) não está disponível no seu plano atual.</p><p>Faça upgrade para liberar este recurso.</p>',
        confirmButtonText: 'Entendi',
        confirmButtonColor: '#23bd9e',
      });
      return;
    }

    // Validação: Certificado A3 só permite NFS-e Prefeitura pela plataforma
    if (parseInt(tipoCertificado) === 1) {
      // Se tentar selecionar NFe (0), CTe (1) ou deixar NFSe sem definir origem
      if (tipoSelecionado === '0') {
        Swal.fire({
          icon: 'info',
          title: 'Consulta com certificado A3',
          html: '<p>Com certificado A3, as consultas de <strong>NF-e</strong> devem ser feitas manualmente pelo aplicativo <strong>Espião Monitor</strong> no computador onde o cartão/pendrive está conectado.</p><p>Para consultas automáticas pela plataforma, utilize certificado A1.</p>',
        });
        return;
      }
      if (tipoSelecionado === '1') {
        Swal.fire({
          icon: 'info',
          title: 'Consulta com certificado A3',
          html: '<p>Com certificado A3, as consultas de <strong>CT-e</strong> devem ser feitas manualmente pelo aplicativo <strong>Espião Monitor</strong> no computador onde o cartão/pendrive está conectado.</p><p>Para consultas automáticas pela plataforma, utilize certificado A1.</p>',
        });
        return;
      }
      // Se selecionar NFSe (2), força para Prefeitura (0)
      if (tipoSelecionado === '2') {
        setRbNFSe('0'); // Força Prefeitura
      }
    }

    setTipoDocCons(tipoSelecionado);
    if (tipoSelecionado === '0') {
      setBgSelectNfe('bg-success text-white');
      setBgSelectCte('');
      setBgSelectNfse('');
    } else if (tipoSelecionado === '1') {
      setBgSelectNfe('');
      setBgSelectCte('bg-success text-white');
      setBgSelectNfse('');
    } else if (tipoSelecionado === '2') {
      setBgSelectNfe('');
      setBgSelectCte('');
      setBgSelectNfse('bg-success text-white');
    } else if (tipoSelecionado === '3') {
      // Origem histórico NFS-e (Municipal)
      let tipoServico_ = state.tipoConsulta[1];
      let periodoNfse_ = state.tipoConsulta[2];
      //let municipioSelecionado = state.tipoConsulta[3] || null;

      // seta município vindo do histórico (ou null se não tiver)
      //setSelectedMunicipio(municipioSelecionado);
      setTipoServico({...tipoServico_, isDisabled: false});
      setPeriodoNfse(periodoNfse_);

      setRbNFSe('0');
      setTipoDocCons('2');
      setBgSelectNfe('');
      setBgSelectCte('');
      setBgSelectNfse('bg-success text-white');
    } else if (tipoSelecionado === '4') {
      // Origem histórico NFSe (Ambas)
      setTipoDocCons('2');
      setBgSelectNfe('');
      setBgSelectCte('');
      setBgSelectNfse('bg-success text-white');
    }
  };
  // cont para teste do alerta

  const d = '02/05/2024 12:00:00'; // Data da NFe 60 dias atrás
  // Calcular a diferença de dias da última consulta
  const dataNfe = dataHoraNfe !== undefined && dataHoraNfe !== null && dataHoraNfe !== '' ? dataHoraNfe.split(' ')[0] : null;

  const dataNfeMoment = moment(dataNfe, 'DD/MM/YYYY');

  const dataAtual = moment(); // Usar a data atual
  const difNfe = dataAtual.diff(dataNfeMoment, 'days');

  const setAlertNfe = () => {
    // Função para exibir alerta se não ocorreu consulta a mais de 60 dias
    if (difNfe > 60 || dataHoraNfe === null || dataHoraNfe === '' || Number(empselecionada.maior_nsu_nfe) === 0) {
      return (
        <div className='p-1'>
          <p className='mb-0'>
            <span className='mdi mdi-alert text-warning mr-1 f-16'></span>
            <strong>Aviso</strong>
          </p>
          <small className='p-0'>
            A SEFAZ pode não liberar os documentos de períodos anteriores.
            <a
              href='https://www.espiaonfe.com.br/lab/quais-sao-as-regras-para-consultar-nfe-na-sefaz/'
              target='_blank'
              rel='noreferrer'
            >
              Saiba mais
            </a>
            .{' '}
          </small>
        </div>
      );
    }
  };

  /**
   * Sugere ativação de consulta automática
   * @param {string} tipoDoc - Tipo de documento (nfe, cte, nfse)
   * @returns {Promise<boolean>} - True se usuário quer ativar
   */
  const sugerirAtivacaoAutomatica = async (tipoDoc) => {
    const docNome = tipoDoc === 'nfe' ? 'NF-e' : tipoDoc === 'cte' ? 'CT-e' : 'NFS-e Nacional';

    // Planos:
    // '1' = BASIC
    // '2' = VIP
    // '3' = FREEDOM
    // '5' = DEMONSTRAÇÃO

    let planoPermite = true;
    let mensagemPlano = '';

    /**
     * Regras:
     * NF-e  -> todos os planos
     * CT-e  -> VIP (2), FREEDOM (3), DEMO (5)
     * NFS-e -> SOMENTE FREEDOM (3) e DEMO (5)
     */

    // CT-e
    if (tipoDoc === 'cte') {
      if (!['2', '3', '5'].includes(planoAtual)) {
        planoPermite = false;
        mensagemPlano = `
        <p class="text-warning mt-2">
          <strong>⚠️ Seu plano atual não permite consulta automática de ${docNome}</strong>
        </p>
        <p>A consulta automática de ${docNome} está disponível a partir do <strong>Plano VIP</strong>.</p>
        <p>Entre em contato para fazer upgrade e liberar este recurso.</p>
      `;
      }
    }

    // NFS-e
    if (tipoDoc === 'nfse') {
      if (!['3', '5'].includes(planoAtual)) {
        // Bloqueio silencioso (não sugere nem mostra upgrade)
        return false;
      }
    }

    // Exibir mensagem de plano (quando aplicável)
    if (!planoPermite) {
      await Swal.fire({
        title: 'Recurso Indisponível no Seu Plano',
        icon: 'info',
        html: mensagemPlano,
        confirmButtonText: 'Entendi',
        confirmButtonColor: '#23bd9e',
        target: '.modal-body',
      });
      return false;
    }

    // Opções de período
    const periodosOptions = {
      1: 'Padrão (24h) - Consulta a cada 1h durante todo o dia',
      2: 'Manhã - Consulta a cada 1h das 6h às 12h',
      3: 'Tarde - Consulta a cada 1h das 12h às 18h',
      4: 'Noite - Consulta a cada 1h das 18h às 24h',
      5: 'Madrugada - Consulta a cada 1h das 0h às 6h',
    };

    const result = await Swal.fire({
      title: 'Ativar Consulta Automática',
      icon: 'question',
      html: `
      <p>Esta empresa não possui consulta automática de <strong>${docNome}</strong> ativada.</p>
      <p><strong>Benefícios:</strong></p>
      <ul style="text-align: left; padding-left: 20px; margin-bottom: 15px;">
        <li>Receber documentos automaticamente a cada 1 hora</li>
        <li>Escolher o período de consulta</li>
        <li>Economizar tempo e não perder documentos</li>
      </ul>
      <label class="text-left d-block mb-2"><strong>Selecione o período:</strong></label>
      <select id="selectPeriodoAuto" class="form-control">
        <option value="1">${periodosOptions['1']}</option>
        <option value="2">${periodosOptions['2']}</option>
        <option value="3">${periodosOptions['3']}</option>
        <option value="4">${periodosOptions['4']}</option>
        <option value="5">${periodosOptions['5']}</option>
      </select>
      <p class="mt-3">
        <small>
          <strong>Recomendação:</strong> Ative a consulta automática para receber documentos regularmente
          e evitar consumo indevido da SEFAZ com consultas manuais frequentes.
        </small>
      </p>
    `,
      showCancelButton: true,
      confirmButtonText: 'Ativar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#23bd9e',
      cancelButtonColor: '#6c757d',
      target: '.modal-body',
      reverseButtons: true,
      preConfirm: () => {
        const select = document.getElementById('selectPeriodoAuto');
        return select ? select.value : '1';
      },
    });

    if (!result.isConfirmed) return false;

    const periodoSelecionado = result.value || '1';

    Swal.fire({
      title: 'Ativando...',
      html: 'Aguarde enquanto ativamos a consulta automática',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      target: '.modal-body',
      didOpen: () => Swal.showLoading(),
    });

    try {
      const empresaRecordId = empselecionada.value || empselecionada.id;

      const response = await axios.get('/api/dashboard/', {
        dest: 'ativarConsultarAutoPorHistorico',
        dataPost: [tipoDoc, empresaRecordId, false, periodoSelecionado],
      });

      if (!response.data?.success) {
        throw new Error('Resposta inválida do servidor');
      }

      const empresaAtualizada = {...empselecionada};

      if (tipoDoc === 'nfe') empresaAtualizada.anfe = periodoSelecionado;
      if (tipoDoc === 'cte') empresaAtualizada.acte = periodoSelecionado;
      if (tipoDoc === 'nfse') empresaAtualizada.anfse = periodoSelecionado;

      setempselecionada(empresaAtualizada);

      await Swal.fire({
        title: 'Sucesso!',
        icon: 'success',
        html: `
        <p>Consulta automática de <strong>${docNome}</strong> ativada com sucesso!</p>
        <p><strong>Período:</strong> ${periodosOptions[periodoSelecionado]}</p>
        <p class="mt-2">
          <small>A partir de agora, os documentos serão consultados automaticamente no período selecionado.</small>
        </p>
      `,
        confirmButtonText: 'OK',
        confirmButtonColor: '#23bd9e',
        timer: 3000,
        target: '.modal-body',
      });

      dispatch({type: UPDATEDATAINI, updateDataIni: true});

      return true;
    } catch (error) {
      await Swal.fire({
        title: 'Erro',
        icon: 'error',
        html: 'Não foi possível ativar a consulta automática. Tente novamente.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#dc3545',
        target: '.modal-body',
      });

      return false;
    }
  };

  const verificarConsultaRecente = async (ultimaConsulta) => {
    const dataUltimaConsulta = moment(ultimaConsulta);
    const proximaConsultaRecomendada = moment(ultimaConsulta).add(1, 'hour').add(1, 'minute');
    const agora = moment();

    if (agora.isBefore(proximaConsultaRecomendada)) {
      const result = await Swal.fire({
        title: 'Alerta de consulta recente',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#23bd9e',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        target: '.modal-body',
        allowOutsideClick: false,
        reverseButtons: true,
        html: `Foi realizada recentemente (menos de 1h atrás) uma consulta para essa empresa às ${dataUltimaConsulta.format('HH:mm')}.<br/><br/>
            <span class="f-w-600">RECOMENDAÇÃO</span><br/>
            Fazer nova consulta a partir das ${proximaConsultaRecomendada.format('HH:mm')}<br/><br/>
            Deseja aguardar o horário recomendado?`,
      });
      if (result.isConfirmed) {
        return true;
      }
      return false;
    }
  };

  /**
   * Consulta documentos na SEFAZ ou prefeituras
   *
   * TipoDoc = 0 = NFE
   * TipoDoc = 1 = CTE
   * TipoDoc = 2 = NFSE
   *
   * @return {*}
   */

  const verificarMenusDisponiveis = (configContext, storageGeral) => {
    let existeHistoricoNfe = false; // verifica se existe histórico de nfe
    let existeHistoricoCte = false; // verifica se existe histórico de cte
    let existeMenuCertificados = false; // verifica se existe menu de certificados
    let existeMenuEmpresas = false; // verifica se existe menu de empresas

    const menus = configContext?.state?.menuUsuario?.length ? configContext.state.menuUsuario?.[0]?.items : storageGeral[10]?.[0]?.items || [];

    menus.forEach((item) => {
      if (item.id === '4' && item.children) {
        const temCertificados = item.children.find((child) => child.id === '31');

        const temEmpresas = item.children.find((child) => child.id === '13');
        if (temCertificados) {
          existeMenuCertificados = true;
        }
        if (temEmpresas) {
          existeMenuEmpresas = true;
        }
      }
      if (item.id === '12' && item.children) {
        const temHistoricoNfe = item.children.find((child) => child.id === '3');
        if (temHistoricoNfe) existeHistoricoNfe = true;
        const temHistoricoCte = item.children.find((child) => child.id === '5');
        if (temHistoricoCte) existeHistoricoCte = true;
      }
    });
    return {existeHistoricoNfe, existeHistoricoCte, existeMenuCertificados, existeMenuEmpresas};
  };

  const handleEspionar = async () => {
    // Se não houver tipo de documento selecionado, não prossegue
    if (tipoDocCons === '-1') {
      return;
    }

    // Certificado A3: não deve realizar consulta automática para NF-e ou CT-e
    // e, para NFS-e, somente é permitido quando a origem for Prefeitura
    const isA3 = parseInt(tipoCertificado) === 1;
    const isNfse = tipoDocCons === '2';
    const isPrefeitura = isNfse && rbNFSe === '0';

    if (isA3 && (!isNfse || !isPrefeitura)) {
      Swal.fire({
        icon: 'info',
        title: 'Consulta com certificado A3',
        html: '<p>Com certificado A3, as consultas de NF-e e CT-e, ou NFS-e Nacional, devem ser feitas manualmente pelo aplicativo <strong>Espião Monitor</strong>.</p><p>Abra o Espião Monitor no computador onde o cartão/pendrive A3 está conectado e realize a consulta por lá.</p>',
      });
      return;
    }

    if (tipoDocCons !== '2') {
      if (empselecionada.value === 0) {
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
        Swal.fire({
          title: 'Ops!',
          icon: 'error',
          html: 'Selecione uma empresa para continuar.',
        }).then(() => {
          dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: true});
        });
      } else {
        if (tipoDocCons === '0') {
          handleEspionarNfe();
        } else if (tipoDocCons === '1') {
          handleEspionarCte();
        }
      }
    } else if (tipoDocCons === '2') {
      // NFS-e (respeitando as regras de certificado já validadas acima)
      // Planos 1 e 4 não podem espionar NFS-e
      if (['1', '4'].includes(String(planoAtual))) {
        Swal.fire({
          icon: 'info',
          title: 'Recurso indisponível no seu plano',
          html: '<p>A consulta de <strong>NFS-e</strong> (Nacional e Prefeituras) não está disponível no seu plano atual.</p><p>Faça upgrade para liberar este recurso.</p>',
          confirmButtonText: 'Entendi',
          confirmButtonColor: '#23bd9e',
        });
        return;
      }
      handleEspionarNfse();
    }
  };

  const handleEspionarNfe = async () => {
    // Verificar se consulta automática NÃO está ativada e sugerir ativação
    // NF-e: sugestão disponível para todos os planos
    if ((!empselecionada.anfe || empselecionada.anfe === '0' || empselecionada.anfe === 0) && empselecionada.tipo === '0') {
      // Mostrar aviso sugerindo ativar consulta automática
      const result = await Swal.fire({
        title: 'Consulta Manual',
        icon: 'info',
        html: `<p>Você está realizando uma consulta manual.</p>
               <p><strong>Recomendação:</strong> Ative a consulta automática para:</p>
               <ul style="text-align: left; padding-left: 20px; margin-bottom: 15px;">
                 <li>Receber documentos automaticamente</li>
                 <li>Evitar consumo indevido na SEFAZ</li>
                 <li>Economizar tempo</li>
               </ul>
               <p>Deseja ativar agora?</p>`,
        showCancelButton: true,
        confirmButtonText: 'Ativar Consulta Automática',
        cancelButtonText: 'Continuar com Manual',
        confirmButtonColor: '#23bd9e',
        cancelButtonColor: '#6c757d',
        target: '.modal-body',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        const ativou = await sugerirAtivacaoAutomatica('nfe');
        if (ativou) return;
      }
    }

    const dataPost = [rbPeriodo, rbManif, rbNsu, txtNsuValue, empselecionada.cnpj_cpf];
    const deveAguardar = await verificarConsultaRecente(empselecionada.ultima_consulta);
    if (deveAguardar) {
      setEspionando(false);
      setEnablePesquisar(true);
      return;
    }
    setEspionando(true);
    setEnablePesquisar(false);

    axios
      .post('/api/consultas/', {dest: 'espionarA1', dataPost})
      .then((response) => {
        const response_ = response.data;

        if (response_ !== 'nao encontrou') {
        }
        //000 = Certificado vencido
        //001 = Certificado não localizado
        //002 = Erro ao ler certificado digital

        //003 = Erro de comunicação com a SEFAZ
        //004 = Erro não catalogado

        //006 = Erro de comunicação da SEFAZ
        //007 = Problemas ao ler retorno da SEFAZ

        //137 = Não localizou novos documentos
        //138 = Foram encontrados novos documentos
        //656 = A consulta retornou consumo indevido
        //593 = CNPJ-Base consultado difere do CNPJ-Base do Certificado Digital
        const codigoRet = response_.cod;
        const motivoRet = response_.motivo;
        const seq = response_.seq;

        let textoBotaoRedirect = ''; // Texto do botão de redirecionamento
        let msgAdicional = ''; // Mensagem adicional
        let linkRedirect = ''; // Link de redirecionamento
        let iconSwal = ''; // Icone do sweetalert
        let titleSwal = ''; // Titulo do sweetalert
        let linkConsumoIndevido = 'https://www.espiaonfe.com.br/lab/consumo-indevido-conheca-as-regras-de-consulta-nfe-da-sefaz/'; // Link de consumo indevido
        let linkSaibaMais = 'https://www.espiaonfe.com.br/lab/quais-sao-as-regras-para-consultar-nfe-na-sefaz/'; // Link de saiba mais
        let linkCertificadoDigital = 'https://www.espiaonfe.com.br/lab/?i=o-que-e-certificado-digital-e-para-que-serve-conheca-as-principais-duvidas'; // Link de certificado digital

        let ExibeRedrecionar = false; // Exibe ou nao botão de redirecionamento

        const {existeHistoricoNfe, existeMenuCertificados, existeMenuEmpresas} = verificarMenusDisponiveis(configContext, storageGeral);

        if (codigoRet === '000') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/certificados';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>
                <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
          textoBotaoRedirect = existeMenuCertificados === true ? 'Gerenciar Certificados' : '';
        } else if (codigoRet === '001') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/certificados';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>
                <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
          textoBotaoRedirect = existeMenuCertificados === true ? 'Gerenciar Certificados' : '';
        } else if (codigoRet === '002') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/certificados';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>
                <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
          textoBotaoRedirect = existeMenuCertificados === true ? 'Gerenciar Certificados' : '';
        } else if (codigoRet === '003') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `<small>
                <p class='f-18'>${motivoRet}</p>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Ver no Histórico NF-e' : '';
        } else if (codigoRet === '004') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `
                <p class='f-18'>Ocorreu um problema inesperado, tente novamente daqui a alguns minutos!</p>
                <small><a href=${linkSaibaMais} target="_blank">Saiba mais sobre a consulta aqui.</a></small>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Ver no Histórico NF-e' : '';
        } else if (codigoRet === '006') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Histórico de NF-e' : '';
        } else if (codigoRet === '007') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Histórico de NF-e' : '';
        } else if (codigoRet === '137') {
          ExibeRedrecionar = true;
          let mensagemAdicional = '';
          if (difNfe > 60 || dataHoraNfe !== null || dataHoraNfe !== '' || Number(empselecionada.maior_nsu_nfe) === 0) {
            mensagemAdicional = `
                   <div class='p-1'>
                    <p class='mb-0'>
                      <span class='mdi mdi-alert text-warning mr-1 f-16'></span>
                      <strong>Aviso</strong>
                    </p>
                    <small class='p-0'>
                      A SEFAZ pode não liberar os documentos de períodos anteriores.
                      <a
                        href='https://www.espiaonfe.com.br/lab/quais-sao-as-regras-para-consultar-nfe-na-sefaz/'
                        target='_blank'
                      >
                        Saiba mais
                      </a>
                      
                    </small>
                  </div>
                  `;
          }

          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `
                <p class='f-18'>${motivoRet}</p>
                ${mensagemAdicional}`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Ver no Histórico NF-e' : '';
        } else if (codigoRet === '138' || motivoRet.indexOf('encontrou novos') > -1) {
          ExibeRedrecionar = true;
          iconSwal = 'success';
          titleSwal = 'Sucesso!';
          linkRedirect = '/history/nfe';
          msgAdicional = `
                <p class='f-18'>Encontramos novos documentos na SEFAZ! 🚀📄</p>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Ver no Histórico NF-e' : '';
          sessionStorage.setItem(`ddesp`, base64_encode(JSON.stringify(sessiosS)));
          dispatch({type: UPDATEDATAINI, updateDataIni: true});
        } else if (codigoRet === '656') {
          iconSwal = 'warning';
          titleSwal = 'Alerta de consulta recente';
          msgAdicional = `
                    <p class='f-18'>
                          Uma consulta foi feita para esta empresa na SEFAZ há menos de 1 hora.
                          Tente novamente em 60 minutos</p>
                    <small><a href=${linkConsumoIndevido} target="_blank">Saiba mais sobre o consumo indevido aqui.</a></small> `;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Histórico de NF-e' : '';
          linkRedirect = '/history/nfe';
        } else if (codigoRet === '593') {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          msgAdicional = `
                    <p class='f-18'>${motivoRet}</p>`;
          linkRedirect = '/history/nfe';
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Histórico de NF-e' : '';
        } else {
          iconSwal = 'error';
          titleSwal = 'Ops!';
          linkRedirect = '/history/nfe';
          msgAdicional = `<p class='f-18'>Problema ao localizar o certificado digital.</p>`;
          textoBotaoRedirect = existeHistoricoNfe === true ? 'Histórico de NF-e' : '';
        }

        Swal.fire({
          title: titleSwal,
          icon: iconSwal,
          html: msgAdicional,
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          target: '.modal-body',
          confirmButtonText: 'Voltar',
          confirmButtonColor: '#2ed8b6',
          denyButtonColor: '#4099ff',
          denyButtonText: textoBotaoRedirect,
          showDenyButton: ExibeRedrecionar,
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch({type: SEQPESQNFE, seqPesqNfe: -1});
            dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
          } else if (result.isDenied) {
            //Verifica se achou notas, ai armazena a sequencia
            if (textoBotaoRedirect.length > 0) {
              dispatch({type: SEQPESQNFE, seqPesqNfe: [seq, empselecionada.value]});
              dispatch({ type: UPDATEDATAINI, updateDataIni: true });
               setEspionando(false);
               setEnablePesquisar(true);
            } else {
              dispatch({ type: SEQPESQNFE, seqPesqNfe: -1 });
               setEspionando(false);
               setEnablePesquisar(true);
            }
            dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
            history.push(linkRedirect);
             setEspionando(false);
             setEnablePesquisar(true);
          } else {
            dispatch({type: SEQPESQNFE, seqPesqNfe: -1});
            dispatch({ type: ESPIONAR_SEFAZ, espionarSefaz: false });
             setEspionando(false);
             setEnablePesquisar(true);
          }
        });

      // dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
      })
      .catch((error) => {
        Swal.fire({
          title: 'Ops!',
          icon: 'error',
          text: 'Problemas ao realizar a consulta. Tente novamente mais tarde.',
        });
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
        setEspionando(false);
        setEnablePesquisar(true);
      });
  };

  const handleEspionarNfse = async () => {
    // Verificar se consulta automática NÃO está ativada para NFS-e Nacional e sugerir ativação
    // NFS-e: sugestão apenas para planos FREEDOM (3) ou DEMONSTRAÇÃO (5)
    const permiteSugerir = planoId === '3' || planoId === '5';

    if (rbNFSe === '1' && (!empselecionada.anfse || empselecionada.anfse === '0' || empselecionada.anfse === 0) && empselecionada.tipo === '0' && permiteSugerir) {
      // Mostrar aviso sugerindo ativar consulta automática
      const result = await Swal.fire({
        title: 'Consulta Manual',
        icon: 'info',
        html: `<p>Você está realizando uma consulta manual de NFS-e.</p>
               <p><strong>Recomendação:</strong> Ative a consulta automática para:</p>
               <ul style="text-align: left; padding-left: 20px; margin-bottom: 15px;">
                 <li>Receber documentos automaticamente</li>
                 <li>Evitar consumo indevido</li>
                 <li>Economizar tempo</li>
               </ul>
               <p>Deseja ativar agora?</p>`,
        showCancelButton: true,
        confirmButtonText: 'Ativar Consulta Automática',
        cancelButtonText: 'Continuar com Manual',
        confirmButtonColor: '#23bd9e',
        cancelButtonColor: '#6c757d',
        target: '.modal-body',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        const ativou = await sugerirAtivacaoAutomatica('nfse');
        if (ativou) return;
      }
    }

    setEspionando(true);
    setEnablePesquisar(false);

    // rbNfse = 1 = nacional, 0 = municipal
    // empselecionada.cnpj_cpf = cnpj da empresa
    // rbNsuNfse = 0 = Último NSU, 1 = A partir do NSU
    // txtNsuValueNfse = NSU digitado
    // periodoNfse[0] = data inicial
    // periodoNfse[1] = data final
    // inscricaoMunicipal = inscrição municipal
    // tipoServico.value = 1 = Prestados, 2 = Tomados

    const im = inscricaoMunicipal !== null ? inscricaoMunicipal.replace(/[^0-9]/g, '').substring(0, 20) : '';

    const usertxt = document.getElementById('txtUsuarioMunicipio');
    const senhatxt = document.getElementById('txtSenhaMunicipio');
    let UsuarioMun = '';
    let SenhaMun = '';

    if (usertxt !== undefined && usertxt !== null) {
      UsuarioMun = usertxt.value;
    }

    if (senhatxt !== undefined && senhatxt !== null) {
      SenhaMun = senhatxt.value;
    }

    // let municipioSelecionado = selectedMunicipioByHistory?.value
    //   ? selectedMunicipioByHistory.label // Origem histórico
    //   : selectedMunicipio.label; // Origem modal espionar
    //

    const dataPost = [rbNFSe, empselecionada.cnpj_cpf, rbNsuNfse, txtNsuValueNfse, periodoNfse[0], periodoNfse[1], im, tipoServico.value, selectedMunicipio.value, UsuarioMun, SenhaMun];

    const dataUltima = moment(empselecionada.ultima_consulta_nfse, 'DD/MM/YYYY HH:mm:ss');
    const dataUltimaNfse = moment(empselecionada.ultima_consulta_nfse, 'DD/MM/YYYY HH:mm:ss').add(1, 'hour').add(1, 'minute');

    const agora = moment();

    let break_ = false;

    if (agora.isBefore(dataUltimaNfse)) {
      //dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
      await Swal.fire({
        title: 'Alerta de consulta recente',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#23bd9e',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        target: '.modal-body',
        html: `Foi realizada recentemente (menos de 1h atrás) uma consulta para essa empresa às ${dataUltima.format('HH:mm')}.<br/><br/>
              <span class="f-w-600">RECOMENDAÇÃO</span><br/>
              Fazer nova consulta a partir das ${dataUltimaNfse.format('HH:mm')}<br/><br/>
              Deseja aguardar o horário recomendado?`,
      }).then((result) => {
        if (result.isConfirmed) {
          setEnablePesquisar(true);
          break_ = true;
        }
        setEspionando(false);
      });
    }
    if (break_) {
      return;
    }

    setEspionando(true);

    axios
      .post('/api/consultas/', {dest: 'espionarNfseNaA1', dataPost})
      .then((response) => {
        let motivoRet = response.data;

        let linkRedirect = '';

        let textoBotaoRedirect = '';
        setEspionando(false);
        setEnablePesquisar(true);
        if (motivoRet[0] === 138 || motivoRet[0] === '138') {
          linkRedirect = '/history/nfse';
          Swal.fire({
            title: 'Pronto!',
            icon: 'success',
            html: motivoRet[1],
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            confirmButtonText: 'Voltar',
            confirmButtonColor: '#2ed8b6',
            denyButtonColor: '#4099ff',
            denyButtonText: 'Histórico de NFSe',
            showDenyButton: true,
            target: '.modal-body',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {

           //   dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
              history.push(linkRedirect);
            }
            // dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
            sessiosS[38] = false;
            sessionStorage.setItem(`ddesp`, base64_encode(JSON.stringify(sessiosS)));
            dispatch({type: UPDATEDATAINI, updateDataIni: true});
          });
        } else {
          linkRedirect = '/history/nfse';
          let motivo = motivoRet[1];

          if (motivoRet[0] === '000' || motivoRet[0] === '137' || motivoRet[0] === 0 || motivoRet[0] === '0') {
            motivoRet = `
            <span>Não localizamos documentos no período selecionado.</span>
            <button class="btn btn-link p-0 text-primary" id='btn-info-NSFe'>Saiba mais</button>
          `;
          } else {
            if (motivoRet[1].indexOf('5 minutos') < -1) {
              motivoRet = `
              <span>Foi efetuada uma consulta recente, aguarde 5 minutos para poder realizar outra consulta!</span></br>
              <button class="btn btn-link p-0 text-primary" id='btn-info-NSFe'>Saiba mais</button>`;
            } else {
              if (motivoRet[1].indexOf('NFS-e não encontrada') > -1) {
                motivoRet = `
              <span>Não localizamos documentos no período selecionado.</span></br>
              <button class="btn btn-link p-0 text-primary" id='btn-info-NSFe'>Saiba mais</button>`;
              }
              motivoRet = `
            <span>Não foi possível completar a consulta.</span></br>
            <button class="btn btn-link p-0 text-primary" id='btn-info-NSFe'>Saiba aqui o motivo</button>`;
            }
          }
          // motivoRet =
          //   motivoRet[0] === '000' || motivoRet[0] === '137' || motivoRet[0] === '0'
          //     ? `
          //   <span>Não localizamos documentos no período selecionado.</span>
          //   <button type="button" class="btn btn-link p-0" data-toggle="tooltip" data-placement="top" title="${motivoRet[1]}">Saiba mais</button>
          // `
          //     : `
          //   <span>Não foi possível completar a consulta.</span></br>
          //   <button class="btn btn-link p-0 text-primary" id='btn-info-NSFe'>Saiba mais</button>
          // `;

          setTimeout(() => {
            // Log do valor do motivo
            let id = document.getElementById('btn-info-NSFe');
            if (id) {
              // Confirma que o botão foi encontrado
              id.addEventListener('click', () => {
                Swal.fire({
                  title: 'Detalhes da consulta',
                  icon: 'info',
                  html: `<p>${motivo}</p>`,
                  target: '.modal-body',
                  confirmButtonText: 'Fechar',
                  confirmButtonColor: '#297BEA',
                });
              });
            } else {
              // Log se o botão não for encontrado
            }
          }, 500); // Aumentado o delay para 500ms

          // motivoRet = motivoRet.replace(/(?:\r\n|\r|\n)/g, '<br>');
          // motivoRet = motivoRet.replace('na API', 'no Sistema');
          Swal.fire({
            icon: 'info',
            html: motivoRet,
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            confirmButtonText: 'Voltar',
            confirmButtonColor: '#2ed8b6',
            denyButtonColor: '#4099ff',
            denyButtonText: textoBotaoRedirect,
            showDenyButton: textoBotaoRedirect.length > 0 ? true : false,
            target: '.modal-body',
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: true});
            } else if (result.isDenied) {
              dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
              history.push(linkRedirect);
            }
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: 'Ops!',
          icon: 'error',
          html: 'Ocorreu um erro ao realizar a consulta. Tente novamente.',
          target: '.modal-body',
        });
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
        setEspionando(false);
        setEnablePesquisar(true);
      });
  };

  const handleEspionarCte = async () => {
    // Verificar se consulta automática NÃO está ativada e sugerir ativação
    // CT-e: sugestão apenas para planos FREEDOM (3) ou DEMONSTRAÇÃO (5)
    const permiteSugerir = planoId === '3' || planoId === '5';

    if ((!empselecionada.acte || empselecionada.acte === '0' || empselecionada.acte === 0) && empselecionada.tipo === '0' && permiteSugerir) {
      // Mostrar aviso sugerindo ativar consulta automática
      const result = await Swal.fire({
        title: 'Consulta Manual',
        icon: 'info',
        html: `<p>Você está realizando uma consulta manual de CT-e.</p>
               <p><strong>Recomendação:</strong> Ative a consulta automática para:</p>
               <ul style="text-align: left; padding-left: 20px; margin-bottom: 15px;">
                 <li>Receber documentos automaticamente</li>
                 <li>Evitar consumo indevido na SEFAZ</li>
                 <li>Economizar tempo</li>
               </ul>
               <p>Deseja ativar agora?</p>`,
        showCancelButton: true,
        confirmButtonText: 'Ativar Consulta Automática',
        cancelButtonText: 'Continuar com Manual',
        confirmButtonColor: '#23bd9e',
        cancelButtonColor: '#6c757d',
        target: '.modal-body',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        const ativou = await sugerirAtivacaoAutomatica('cte');
        if (ativou) return;
      }
    }

    const periodoCte = Number(empselecionada.maior_nsu_cte) === 0 ? rbPeriodoCte : 90;

    const dataPost = [Number(periodoCte), rbTomador, rbNsuCte, txtNsuValueCte, empselecionada.cnpj_cpf];
    const deveAguardar = await verificarConsultaRecente(empselecionada.ultima_consulta_cte);
    if (deveAguardar) {
      setEspionando(false);
      setEnablePesquisar(true);
      return;
    }
    setEspionando(true);
    setEnablePesquisar(false);
    axios
      .post('/api/consultas/', {dest: 'espionarCteA1', dataPost})
      .then((response) => {
        const {cod: codigoRet, motivo: motivoRet} = response.data;

        let linkRedirect = '';
        let msgAdicional = '';
        let textoBotaoRedirect = '';
        let iconSwal = '';
        let titleSwal = '';

        let linkConsumoIndevido = 'https://www.espiaonfe.com.br/lab/consumo-indevido-conheca-as-regras-de-consulta-nfe-da-sefaz/';
        let linkSaibaMais = 'https://www.espiaonfe.com.br/lab/quais-sao-as-regras-para-consultar-nfe-na-sefaz/';
        let linkCertificadoDigital = 'https://www.espiaonfe.com.br/lab/?i=o-que-e-certificado-digital-e-para-que-serve-conheca-as-principais-duvidas';

        const {existeHistoricoCte, existeMenuCertificados} = verificarMenusDisponiveis(configContext, storageGeral);

        switch (codigoRet) {
          case '000':
            iconSwal = 'error';
            titleSwal = 'Ops!';
            linkRedirect = '/certificados';
            msgAdicional = `
            <p class='f-18'>${motivoRet}</p>
            <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
            textoBotaoRedirect = existeMenuCertificados ? 'Gerenciar Certificados' : '';
            break;
          case '001':
            iconSwal = 'error';
            titleSwal = 'Ops!';
            linkRedirect = '/certificados';
            msgAdicional = `
            <p class='f-18'>${motivoRet}</p>
            <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
            textoBotaoRedirect = existeMenuCertificados ? 'Gerenciar Certificados' : '';
            break;
          case '002':
            linkRedirect = '/certificados';
            msgAdicional = `
            <p class='f-18'>${motivoRet}</p>
            <small><a href=${linkCertificadoDigital} target="_blank">Saiba mais sobre o certificado digital aqui.</a></small>`;
            textoBotaoRedirect = existeMenuCertificados ? 'Gerenciar Certificados' : '';
            break;
          case '003':
          case '004':
          case '006':
          case '007':
          case '137':
            iconSwal = 'error';
            titleSwal = 'Ops!';
            linkRedirect = '/history/cte';
            msgAdicional = `
             <p class='f-18'>${motivoRet}</p>
            <small><a href=${linkSaibaMais} target="_blank">Saiba mais sobre a consulta aqui.</a></small>`;
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
            break;
          case '008': // Saldo insuficiente
            iconSwal = 'warning';
            titleSwal = 'Ops!';
            linkRedirect = '/history/cte';
            if (planoAtual !== '5') {
              msgAdicional = `
              <p class='f-18'>Limite de armazenamento atingido.</p>
              <p class='f-16'>
                Os documentos foram armazenados até o limite disponível. 
               Para continuar consultando, é necessário aumentar o limite de armazenamento.
              </p>
              <button class="btn btn-link p-0 text-primary" id="btnConfigurarLimiteCte">
                Configurar limite de armazenamento CT-e
              </button>
            `;
            } else {
              msgAdicional = `
              <p class='f-18'>Limite de armazenamento atingido.</p>
              <p class='f-16'>
                Os documentos foram armazenados até o limite disponível para demonstração.
                <br /> 
                Para continuar consultando, é necessário contratar um plano.
              </p>
            `;
            }
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
            break;
          case '656':
            iconSwal = 'error';
            titleSwal = 'Ops!';
            msgAdicional = `<p class='f-18'>${motivoRet}</p>
                            <small><a href=${linkConsumoIndevido} target="_blank">Saiba mais sobre o consumo indevido aqui.</a></small>`;
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
            break;
          case '593':
            iconSwal = 'error';
            titleSwal = 'Ops!';
            msgAdicional = `<p class='f-18'>${motivoRet}</p>`;
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
            break;
          case '138':
            iconSwal = 'success';
            titleSwal = 'Pronto!';
            linkRedirect = '/history/cte';
            msgAdicional = `
            <p class='f-18'>${motivoRet}</p>
            <small><a href=${linkSaibaMais} target="_blank">Saiba mais sobre a consulta aqui.</a></small>`;
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
            sessionStorage.setItem(`ddesp`, base64_encode(JSON.stringify(sessiosS)));
            dispatch({type: UPDATEDATAINI, updateDataIni: true});
            break;
          default:
            linkRedirect = '/history/cte';
            msgAdicional = `<small><a href=${linkSaibaMais} target="_blank">Saiba mais sobre a consulta aqui.</a></small>`;
            textoBotaoRedirect = existeHistoricoCte ? 'Histórico de CT-e' : '';
        }

        Swal.fire({
          title: titleSwal,
          icon: iconSwal,
          html: msgAdicional,
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          confirmButtonText: 'Voltar',
          confirmButtonColor: '#2ed8b6',
          didOpen: () => {
            const btn = document.getElementById('btnConfigurarLimiteCte');
            if (btn) {
              btn.addEventListener('click', () => {
                handleDirecionarLimiteCte();
                Swal.close();
              });
            }
          },
          denyButtonColor: '#4099ff',
          denyButtonText: textoBotaoRedirect,
          showDenyButton: textoBotaoRedirect.length > 0,
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: true});
          } else if (result.isDenied) {
            dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
            history.push(linkRedirect);
          }
        });

        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
      })
      .catch((error) => {
        Swal.fire({
          title: 'Ops!',
          icon: 'error',
          text: 'Problemas ao realizar a consulta. Tente novamente mais tarde.',
        });
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
        setEspionando(false);
        setEnablePesquisar(true);
      });
  };

  const handleDirecionarLimiteCte = () => {
    dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
    history.push({
      pathname: '/history/cte',
      state: {cardInicial: 'cardConfigCte'},
    });
  };

  function handleKeyUpNSU(e) {
    const nsu = e.target.value.replace(/[^0-9]/g, '');
    setTxtNsuValue(nsu);
  }

  function handleKeyUpNSUCte(e) {
    const nsu = e.target.value.replace(/[^0-9]/g, '');
    setTxtNsuValueCte(nsu);
  }

  function handleKeyUpNSUNfse(e) {
    const nsu = e.target.value.replace(/[^0-9]/g, '');
    setTxtNsuValueNfse(nsu);
  }

  const verificaPermissao = async (e) => {
    if (e === undefined) {
      return;
    }

    const data = configContext.state.menuUsuario;

    if (!Array.isArray(data) || !data[0] || !Array.isArray(data[0].items)) {
      return;
    }

    const find_ = data[0].items.find((item) => item.id === '19');

    //Verifica se o usuario possui o menu de Espionar
    if (find_) {
      const FindMenuNFe = find_.children.find((item) => item.id === '32'); //menu NFe
      const FindMenuCte = find_.children.find((item) => item.id === '37'); //menu CTe
      const FindMenuNfse = find_.children.find((item) => item.id === '38'); //menu NFSe

      let espNfe_ = FindMenuNFe !== undefined ? 't' : 'f'; // Se possui o menu NFe
      let espCte_ = FindMenuCte !== undefined ? 't' : 'f'; // Se possui o menu CTe
      let espNfse_ = FindMenuNfse !== undefined ? 't' : 'f'; // Se possui o menu NFSe

      //aqui tem que comparar com o que a empresa pode tambem...
      //caso seja falso para o menu, entao nao pode espionar de jeito nenhum

      //acho que a maneira mais simples mesmo é um if para cada um
      espNfe_ = espNfe_ === 't' ? (e.espionar_nfe === 't' ? 't' : 'f') : 'f';
      espCte_ = espCte_ === 't' ? (e.espionar_cte === 't' ? 't' : 'f') : 'f';

      espNfse_ = espNfse_ === 't' ? (e.espionar_nfse === 't' ? 't' : 'f') : 'f';

      setArrayPermiteEspionar({nfe: espNfe_, cte: espCte_, nfse: espNfse_});
    } else {
      setArrayPermiteEspionarConta({nfe: 'f', cte: 'f', nfse: 'f'});
    }
    setEnablePesquisar(true);

    if (configContext.state.tipoConsulta !== '-1') {
      // const e = {target: {value: configContext.state.tipoConsulta}};
      //handleTipoDoc(e);
      setTimeout(() => {
        if (parseInt(tipoCertificado) === 0) {
          handleEspionar();
        }
      }, 700);

      dispatch({type: TIPOCONSULTA, tipoConsulta: '-1'});
    }

    // const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
    // const users = JSON.parse(usersRt);

    // //NFe === '32' || Cte === '37' || NFSe === '38');
    // const FindMenuNFe = users[26].find((item) => item.key === '32');
    // const FindMenuCte = users[26].find((item) => item.key === '37');
    // const FindMenuNfse = users[26].find((item) => item.key === '38');

    // const espNfe_ = FindMenuNFe !== undefined ? 'f' : 't';
    // const espCte_ = FindMenuCte !== undefined ? 'f' : 't';
    // const espNfse_ = FindMenuNfse !== undefined ? 'f' : 't';

    // setArrayPermiteEspionar((prevState) => ({...prevState, nfe: espNfe_, cte: espCte_, nfse: espNfse_}));

    // if (FindMenuNFe !== undefined) {
    //   setArrayPermiteEspionarConta((prevState) => ({...prevState, nfe: 'f'}));
    // } else if (FindMenuCte !== undefined) {
    //   setArrayPermiteEspionarConta((prevState) => ({...prevState, cte: 'f'}));
    // } else if (FindMenuNfse !== undefined) {
    //   setArrayPermiteEspionarConta((prevState) => ({...prevState, nfse: 'f'}));
    // }
    return;
  };

  useEffect(() => {
    if (configContext.state.tipoConsulta !== '-1') {
      let tipoConsulta = configContext.state.tipoConsulta;
      if (Array.isArray(tipoConsulta)) {
        tipoConsulta = tipoConsulta[0];
      }
      const e = {target: {value: tipoConsulta}};
      handleTipoDoc(e);
      // setTimeout(() => {
      //   if (parseInt(tipoCertificado) === 0) {
      //     handleEspionar();
      //   }
      // }, 1200);

      dispatch({type: TIPOCONSULTA, tipoConsulta: '-1'});
    }
    const fetchData = async () => {
      const response = await axios.post('/api/initData/', {dest: 'dataIni'});
      const data_ = await response.data;

      //
      if (data_.length === 0) {
        setselectEmpresa([]);
        Swal.fire({
          title: 'Ops!',
          icon: 'error',
          html: 'Você ainda não possui empresas para Espionar.',
        });
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
        return;
      }
      if (data_ === false) {
        setselectEmpresa([]);
        return;
      }

      const filteredData = TrataDataIniEmpresas(data_, moduloAtual);

      setselectEmpresa(filteredData[1]);
      if (filteredData[0].length === 0) {
        return;
      }

      handleChangeEmpresa(filteredData[0]);
    };

    verificaPermissao();
    fetchData();
  }, []);

  useEffect(() => {}, [selectEmpresa]);

  useEffect(() => {
    const fetchSaldo = async () => {
      try {
        const response = await axios.get('/api/initData/', {dest: 'getSaldoCte'});
        const data_ = await response.data;
        setPossuiSaldo(data_ !== 0);
      } catch (error) {
        console.error('Error ao buscar saldo:', error);
        setPossuiSaldo(false);
      }
    };

    const fetchParametros = async () => {
      const paramResponse = await axios.get('/api/perm/', {dest: 'getParametros', dataPost: [13,14, 15, 16]});
      const parametros = await paramResponse.data;
      setParam(parametros);

      if (parametros.length > 0) {
        const param13 = parametros.find((p) => p.item === '13');
        const param14 = parametros.find((p) => p.item === '14');
        const param15 = parametros.find((p) => p.item === '15');
        const param16 = parametros.find((p) => p.item === '16');

        setParamEspionarNfe(param14 ? param14.bool === 't' : true);
        setParamEspionarCte(param15 ? param15.bool === 't' : true);
        setParamEspionarNfse(param16 ? param16.bool === 't' : true);
        setParamMunicipal(param13 ? param13.bool === 't' : false);
      }
    };

    fetchParametros();
    fetchSaldo();
  }, []);

  // Função para renderizar a mensagem de espionando de acordo com o tipo de documento
  const renderMensagemEspionando = () => {
    if (tipoDocCons === '0') return 'Espionando NF-e, aguarde!';
    if (tipoDocCons === '1') return 'Espionando CT-e, aguarde!';

    // let origemEspionando = selectedMunicipioByHistory?.value
    //   ? selectedMunicipioByHistory.label // Origem histórico
    //   : selectedMunicipio.label; // Origem modal espionar
    return `Espionando NFS-e ${tipoServico.label} em ${rbNFSe === '0' ? selectedMunicipio.label : ' Ambiente Nacional'}, aguarde!`;
  };

  return (
    <Modal
      id='modalEspionar'
      size='xl'
      backdrop='static'
      dialogClassName='overflow-auto'
      show={configContext.state.espionarSefaz}
      onHide={() => {
        dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
      }}
    >
      <Modal.Body>
        <h5 className='text-center mt-1 mb-3'>
          <span className='fa fa-search fa-2x text-c-blue'></span>
        </h5>
        <h5 className='text-center mb-0'>Consultar na Sefaz ou nas Prefeituras</h5>
        <hr className='mb-3' />
        <Row className='p-1'>
          <Col
            sm={12}
            className='text-left align-itens-center'
          >
            <Form.Label>Empresas</Form.Label>
            <Select
              className='basic-single tour-1'
              classNamePrefix='select'
              name='empresas'
              placeholder='Carregando empresas...'
              isDisabled={!enablePesquisar}
              value={empselecionada}
              options={selectEmpresa}
              onChange={(e) => handleChangeEmpresa(e)}
            />
            <div className='p-1'>
              {tipoDocCons === '0' && (
                <>
                  <small className='d-block'>Última consulta de NF-e: {dataHoraNfe !== null ? dataHoraNfe : <span className='text-danger'>Nunca consultado</span>}</small>
                  {(empselecionada.l_descricao || empselecionada.l_ultima || empselecionada.l_proxima) && (
                    <div className='mt-2'>
                      <div
                        className='p-2 border rounded bg-light d-flex align-items-center justify-content-between'
                        style={{cursor: 'pointer'}}
                        onClick={() => setExpandirDetalhesAuto(!expandirDetalhesAuto)}
                      >
                        <div className='flex-grow-1'>
                          <small className='text-dark d-block'>
                            <strong>Log consulta automática:</strong> {empselecionada.l_descricao} {empselecionada.l_ultima && `• Executada: ${moment(empselecionada.l_ultima).format('DD/MM/YYYY HH:mm:ss')}`} {empselecionada.l_proxima && empselecionada.anfe && empselecionada.anfe !== '0' && `• Próxima: ${moment(empselecionada.l_proxima).format('DD/MM/YYYY HH:mm:ss')}`}
                          </small>
                        </div>
                        <span className={`mdi mdi-chevron-${expandirDetalhesAuto ? 'up' : 'down'} ml-2 text-primary f-18`}></span>
                      </div>
                      {expandirDetalhesAuto && (
                        <div className='mt-2 p-2 border rounded bg-white'>
                          {empselecionada.l_descricao && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>📋 Resultado da última automática:</strong>
                              </small>
                              <small className='text-dark'>{empselecionada.l_descricao}</small>
                            </div>
                          )}
                          {empselecionada.l_ultima && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>🕐 Última execução:</strong>
                              </small>
                              <small className='text-dark'>{moment(empselecionada.l_ultima).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                          {empselecionada.l_proxima && empselecionada.anfe && empselecionada.anfe !== '0' && (
                            <div>
                              <small className='text-muted d-block'>
                                <strong>⏰ Próxima agendada:</strong>
                              </small>
                              <small className='text-primary'>{moment(empselecionada.l_proxima).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {tipoDocCons === '1' && (
                <>
                  <small className='d-block'>Última consulta de CT-e: {dataHoraCte}</small>
                  {(empselecionada.l_descricaocte || empselecionada.l_ultimacte || empselecionada.l_proximacte) && (
                    <div className='mt-2'>
                      <div
                        className='p-2 border rounded bg-light d-flex align-items-center justify-content-between'
                        style={{cursor: 'pointer'}}
                        onClick={() => setExpandirDetalhesAuto(!expandirDetalhesAuto)}
                      >
                        <div className='flex-grow-1'>
                          <small className='text-dark d-block'>
                            <strong>Log consulta automática:</strong> {empselecionada.l_descricaocte} {empselecionada.l_ultimacte && `• Executada: ${moment(empselecionada.l_ultimacte).format('DD/MM/YYYY HH:mm:ss')}`} {empselecionada.l_proximacte && empselecionada.acte && empselecionada.acte !== '0' && `• Próxima: ${moment(empselecionada.l_proximacte).format('DD/MM/YYYY HH:mm:ss')}`}
                          </small>
                        </div>
                        <span className={`mdi mdi-chevron-${expandirDetalhesAuto ? 'up' : 'down'} ml-2 text-primary f-18`}></span>
                      </div>
                      {expandirDetalhesAuto && (
                        <div className='mt-2 p-2 border rounded bg-white'>
                          {empselecionada.l_descricaocte && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>📋 Resultado da última automática:</strong>
                              </small>
                              <small className='text-dark'>{empselecionada.l_descricaocte}</small>
                            </div>
                          )}
                          {empselecionada.l_ultimacte && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>🕐 Última execução:</strong>
                              </small>
                              <small className='text-dark'>{moment(empselecionada.l_ultimacte).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                          {empselecionada.l_proximacte && empselecionada.acte && empselecionada.acte !== '0' && (
                            <div>
                              <small className='text-muted d-block'>
                                <strong>⏰ Próxima agendada:</strong>
                              </small>
                              <small className='text-primary'>{moment(empselecionada.l_proximacte).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {tipoDocCons === '2' && rbNFSe === '1' && (
                <>
                  <small className='d-block'>Última consulta de NFS-e (Nacional): {dataHoraNfse !== null ? dataHoraNfse : <span className='text-danger'>Nunca consultado</span>}</small>
                  {(empselecionada.l_descricaonfse || empselecionada.l_ultimanfse || empselecionada.l_proximanfse) && (
                    <div className='mt-2'>
                      <div
                        className='p-2 border rounded bg-light d-flex align-items-center justify-content-between'
                        style={{cursor: 'pointer'}}
                        onClick={() => setExpandirDetalhesAuto(!expandirDetalhesAuto)}
                      >
                        <div className='flex-grow-1'>
                          <small className='text-dark d-block'>
                            <strong>Log consulta automática:</strong> {empselecionada.l_descricaonfse} {empselecionada.l_ultimanfse && `• Executada: ${moment(empselecionada.l_ultimanfse).format('DD/MM/YYYY HH:mm:ss')}`} {empselecionada.l_proximanfse && empselecionada.anfse && empselecionada.anfse !== '0' && `• Próxima: ${moment(empselecionada.l_proximanfse).format('DD/MM/YYYY HH:mm:ss')}`}
                          </small>
                        </div>
                        <span className={`mdi mdi-chevron-${expandirDetalhesAuto ? 'up' : 'down'} ml-2 text-primary f-18`}></span>
                      </div>
                      {expandirDetalhesAuto && (
                        <div className='mt-2 p-2 border rounded bg-white'>
                          {empselecionada.l_descricaonfse && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>📋 Resultado da última automática:</strong>
                              </small>
                              <small className='text-dark'>{empselecionada.l_descricaonfse}</small>
                            </div>
                          )}
                          {empselecionada.l_ultimanfse && (
                            <div className='mb-2'>
                              <small className='text-muted d-block'>
                                <strong>🕐 Última execução:</strong>
                              </small>
                              <small className='text-dark'>{moment(empselecionada.l_ultimanfse).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                          {empselecionada.l_proximanfse && empselecionada.anfse && empselecionada.anfse !== '0' && (
                            <div>
                              <small className='text-muted d-block'>
                                <strong>⏰ Próxima agendada:</strong>
                              </small>
                              <small className='text-primary'>{moment(empselecionada.l_proximanfse).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>

        {blqInterno === 'f' || blqInterno === false || blqInterno === 'false' ? (
          tipoCertificado !== -1 ? (
            enablePesquisar === true ? (
              <>
                <Row className='justify-content-center mt-3'>
                  <Col sm={12}>
                    <Row>
                      <Col
                        sm={6}
                        className=''
                      >
                        <div className='ml-3'>
                          <strong className='ml-4'>Qual documento gostaria de consultar agora?</strong>
                          <Form.Group
                            className='tipoDoc'
                            checked={tipoDocCons}
                          >
                            {paramEspionarNfe === true && (
                              <Form.Check
                                custom
                                style={{zIndex: 0}}
                                value={'0'}
                                className='mt-3 rb-w w-100 nfe'
                                type='radio'
                                checked={tipoDocCons === '0' && arrayPermiteEspionar.nfe === 't' && arrayPermiteEspionarConta.nfe === 't' ? true : false}
                                disabled={arrayPermiteEspionar.nfe === 'f' || arrayPermiteEspionarConta.nfe === 'f' || parseInt(tipoCertificado) === 1}
                                onChange={handleTipoDoc}
                                label={
                                  <Card
                                    className={'mb-1 pointer mt-0 ' + bgSelectNfe}
                                    id='card-0'
                                  >
                                    <Card.Body className='p-3 mt-0'>
                                      <strong>NF-e </strong>
                                      {arrayPermiteEspionar.nfe === 'f' || arrayPermiteEspionarConta.nfe === 'f' ? <small className='text-danger f-w-400'> - Não disponível</small> : parseInt(tipoCertificado) === 1 ? <small className='text-warning f-w-400'> - Consulte com A3 pelo Espião Monitor</small> : ''}
                                      <br />
                                      <small>Nota Fiscal Eletrônica</small>
                                      {empselecionada.anfe && empselecionada.anfe !== '0' && empselecionada.anfe !== 0 ? (
                                        <div className='mt-2'>
                                          <span className='badge badge-light-success text-secondary'>
                                            <span className='mdi mdi-clock-check-outline mr-1'></span>
                                            Consulta automática: a cada 1h
                                            {(() => {
                                              const tipo = parseInt(empselecionada.anfe);
                                              switch (tipo) {
                                                case 1:
                                                  return ' (24h - o dia todo)';
                                                case 2:
                                                  return ' (manhã: 6h-12h)';
                                                case 3:
                                                  return ' (tarde: 12h-18h)';
                                                case 4:
                                                  return ' (noite: 18h-24h)';
                                                case 5:
                                                  return ' (madrugada: 0h-6h)';
                                                default:
                                                  return ' (24h - o dia todo)';
                                              }
                                            })()}
                                          </span>
                                        </div>
                                      ) : null}
                                    </Card.Body>
                                  </Card>
                                }
                                name='radioCons'
                                id='radioConsNfe'
                              />
                            )}

                            {paramEspionarCte === true && (
                              <Form.Check
                                custom
                                value={'1'}
                                className='mt-3 rb-w w-100 cte'
                                type='radio'
                                checked={tipoDocCons === '1' && arrayPermiteEspionar.cte === 't' && arrayPermiteEspionarConta.cte === 't' ? true : false}
                                disabled={arrayPermiteEspionar.cte === 'f' || arrayPermiteEspionarConta.cte === 'f' || parseInt(tipoCertificado) === 1}
                                style={{zIndex: 0}}
                                onChange={handleTipoDoc}
                                label={
                                  <Card
                                    className={'mb-1 pointer mt-0 ' + bgSelecCte}
                                    id='card-1'
                                  >
                                    <Card.Body className='p-3 mt-0'>
                                      <strong>CT-e </strong>
                                      {arrayPermiteEspionar.cte === 'f' || arrayPermiteEspionarConta.cte === 'f' ? <small className='text-danger f-w-400'> - Não disponível</small> : parseInt(tipoCertificado) === 1 ? <small className='text-warning f-w-400'> - Consulte com A3 pelo Espião Monitor</small> : ''}
                                      <br />
                                      <small>Conhecimento de Transporte Eletrônico</small>
                                      {empselecionada.acte && empselecionada.acte !== '0' && empselecionada.acte !== 0 ? (
                                        <div className='mt-2'>
                                          <span className='badge badge-light-success text-secondary'>
                                            <span className='mdi mdi-clock-check-outline mr-1'></span>
                                            Consulta automática: a cada 1h
                                            {(() => {
                                              const tipo = parseInt(empselecionada.acte);
                                              switch (tipo) {
                                                case 1:
                                                  return ' (24h - o dia todo)';
                                                case 2:
                                                  return ' (manhã: 6h-12h)';
                                                case 3:
                                                  return ' (tarde: 12h-18h)';
                                                case 4:
                                                  return ' (noite: 18h-24h)';
                                                case 5:
                                                  return ' (madrugada: 0h-6h)';
                                                default:
                                                  return ' (24h - o dia todo)';
                                              }
                                            })()}
                                          </span>
                                        </div>
                                      ) : null}
                                    </Card.Body>
                                  </Card>
                                }
                                name='radioCons'
                                id='radioConsCte'
                              />
                            )}
                            {paramEspionarNfse === true && (
                              <Form.Check
                                custom
                                value={'2'}
                                style={{zIndex: 0}}
                                className='mt-3 rb-w w-100 nfse'
                                type='radio'
                                checked={tipoDocCons === '2' && arrayPermiteEspionar.nfse === 't' && arrayPermiteEspionarConta.nfse === 't' ? true : false}
                                disabled={arrayPermiteEspionar.nfse === 'f' || arrayPermiteEspionarConta.nfse === 'f' || empselecionada.cnpj_cpf === '00000000000001' || ['1', '4'].includes(String(planoAtual))}
                                onChange={handleTipoDoc}
                                label={
                                  <Card
                                    className={'mb-1 pointer mt-0 ' + bgSelectNfse}
                                    id='card-2'
                                  >
                                    <Card.Body className='p-3 mt-0'>
                                      <strong>NFS-e </strong>
                                      {empselecionada.cnpj_cpf === '00000000000001' ? <small className='text-danger f-w-400'> - Não disponível para dados fictícios</small> : ['1', '4'].includes(String(planoAtual)) ? <small className='text-warning f-w-400'> - Indisponível no seu plano</small> : arrayPermiteEspionar.nfse === 'f' || arrayPermiteEspionarConta.nfse === 'f' ? <small className='text-danger f-w-400'> - Não disponível</small> : parseInt(tipoCertificado) === 1 ? <small className='text-info f-w-400'> - Com A3 apenas Prefeituras</small> : ''}
                                      <br />
                                      <small>Nota Fiscal de Serviço Eletrônica</small>
                                      {empselecionada.anfse && empselecionada.anfse !== '0' && empselecionada.anfse !== 0 ? (
                                        <div className='mt-2'>
                                          <span className='badge badge-light-success text-secondary'>
                                            <span className='mdi mdi-clock-check-outline mr-1'></span>
                                            Consulta automática: a cada 1h
                                            {(() => {
                                              const tipo = parseInt(empselecionada.anfse);
                                              switch (tipo) {
                                                case 1:
                                                  return ' (24h - o dia todo)';
                                                case 2:
                                                  return ' (manhã: 6h-12h)';
                                                case 3:
                                                  return ' (tarde: 12h-18h)';
                                                case 4:
                                                  return ' (noite: 18h-24h)';
                                                case 5:
                                                  return ' (madrugada: 0h-6h)';
                                                default:
                                                  return ' (24h - o dia todo)';
                                              }
                                            })()}{' '}
                                            - Nacional
                                          </span>
                                        </div>
                                      ) : null}
                                    </Card.Body>
                                  </Card>
                                }
                                name='radioCons'
                                id='radioConsNfse'
                              />
                            )}
                          </Form.Group>
                        </div>
                      </Col>
                      <Col sm={6}>
                        {parseInt(tipoCertificado) === 0 && tipoDocCons !== '-1' ? (
                          <strong>
                            Opções da consulta{' '}
                            {tipoDocCons !== '2' && (
                              <a
                                className='badge badge-light-primary pointer'
                                onClick={() => setShowOptConsulta(!showOptConsulta)}
                              >
                                <span className='fa fa-cog'></span>
                              </a>
                            )}
                          </strong>
                        ) : (
                          <>
                            {tipoDocCons !== '2' && !espionarA3 && (
                              <Col>
                                <h6 className='text-center'>Selecione ao lado qual documento deseja consultar.</h6>
                              </Col>
                            )}
                          </>
                        )}
                        {
                          /* Opções de consulta NFE */
                          tipoDocCons === '0' ? (
                            parseInt(tipoCertificado) === 0 ? (
                              <OpcoesNfe
                                rbManif={rbManif}
                                setRbManif={setRbManif}
                                showOptConsulta={showOptConsulta}
                                arrStrg={arrStrg}
                                empselecionada={empselecionada}
                                setRbPeriodo={setRbPeriodo}
                                rbNsu={rbNsu}
                                setRbNsu={setRbNsu}
                                txtNsuValue={txtNsuValue}
                                setTxtNsuValue={setTxtNsuValue}
                                handleKeyUpNSU={handleKeyUpNSU}
                                setAlertNfe={setAlertNfe}
                              />
                            ) : (
                              espionarA3
                            )
                          ) : /* Opções de consulta CTE */ tipoDocCons === '1' ? (
                            parseInt(tipoCertificado) === 0 ? (
                              <OpcoesCte
                                rbTomador={rbTomador}
                                setRbTomador={setRbTomador}
                                showOptConsulta={showOptConsulta}
                                arrStrg={arrStrg}
                                empselecionada={empselecionada}
                                setRbPeriodoCte={setRbPeriodoCte}
                                rbNsuCte={rbNsuCte}
                                setRbNsuCte={setRbNsuCte}
                                txtNsuValueCte={txtNsuValueCte}
                                setTxtNsuValueCte={setTxtNsuValueCte}
                                handleKeyUpNSUCte={handleKeyUpNSUCte}
                              />
                            ) : (
                              espionarA3
                            )
                          ) : (
                            tipoDocCons === '2' && (
                              /* Opções de consulta NFSE */
                              <OpcoesNfse
                                rbNFSe={rbNFSe}
                                setRbNFSe={setRbNFSe}
                                periodoNfse={periodoNfse}
                                setPeriodoNfse={setPeriodoNfse}
                                inscricaoMunicipal={inscricaoMunicipal}
                                setInscricaoMunicipal={setInscricaoMunicipal}
                                empSelecionada={empselecionada}
                                rbNsuNfse={rbNsuNfse}
                                setRbNsuNfse={setRbNsuNfse}
                                txtNsuValueNfse={txtNsuValueNfse}
                                setTxtNsuValueNfse={setTxtNsuValueNfse}
                                handleKeyUpNSUNfse={handleKeyUpNSUNfse}
                                tipoServico={tipoServico}
                                setTipoServico={setTipoServico}
                                selectedMunicipio={selectedMunicipio}
                                    setSelectedMunicipio={setSelectedMunicipio}
                                    paramMunicipal={paramMunicipal}
                                // selectedMunicipioByHistory={selectedMunicipioByHistory}
                              />
                            )
                          )
                        }
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            ) : espionando === false ? (
              <h4 className='text-center'>
                <span className='fa fa-spinner fa-spin'></span> Carregando empresas, aguarde!
              </h4>
            ) : (
              <Row>
                <Col>
                  <h5 className='text-center'>
                    <img
                      src={procurando2}
                      alt='Procurando'
                    />
                    <br />
                    {renderMensagemEspionando()}
                  </h5>
                </Col>
              </Row>
            )
          ) : (
            <Row>
              <Col
                sm={12}
                className='text-center'
              >
                <img
                  src={noData}
                  alt='No data'
                  className='img-fluid'
                  style={{maxWidth: '100%', height: 'auto', opacity: 0.7}}
                />
                <p className='f-w-600 f-14'>Esta empresa ainda não possui certificado Digital vinculado.</p>
                <Button
                  variant='success'
                  className='rounded btn-sm mt-3'
                  onClick={() => {
                    dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
                    history.push('/certificados');
                  }}
                >
                  Cadastrar Certificado A1
                </Button>
                <Button
                  variant='primary'
                  className='rounded btn-sm mt-3 ml-3'
                  onClick={() => {
                    dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
                    history.push('/empresas');
                  }}
                >
                  Vincular Certificado A3
                </Button>
              </Col>
            </Row>
          )
        ) : (
          <Row>
            <Col
              sm={12}
              className='text-center'
            >
              <h5 className='text-center'>
                <img
                  src={noData}
                  alt='No data'
                  className='img-fluid'
                  style={{maxWidth: '100%', height: 'auto', opacity: 0.7}}
                />
                <br />
              </h5>
              <span className='f-w-600'>
                Esta empresa está indisponível para consultas por motivo de duplicidade.
                <br />
                <a
                  className='rounded btn-sm text-decoration-none'
                  href={'https://tawk.to/appespiaocloud'}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Liberar acesso!
                </a>{' '}
              </span>
            </Col>
          </Row>
        )}
        <hr />
        <div className='text-center'>
          {/* Certificado vencido - Mostrar aviso e bloquear (para todos os tipos de documento) */}
          {enablePesquisar === true && empselecionada.vcert && moment(empselecionada.vcert).startOf('day').isBefore(moment().startOf('day')) && tipoDocCons !== '-1' ? (
            <>
              <div className='alert alert-danger mb-3'>
                <span className='mdi mdi-certificate mr-2'></span>
                <strong>Certificado vencido!</strong>
                <p className='mb-0 mt-1'>
                  O certificado digital desta empresa venceu em <strong>{moment(empselecionada.vcert).format('DD/MM/YYYY')}</strong>.
                </p>
                <p className='mb-0'>Atualize o certificado para realizar consultas.</p>
              </div>
              {verificarMenusDisponiveis(configContext, storageGeral).existeMenuCertificados ? (
                <Button
                  variant='danger'
                  className='rounded tour-2'
                  onClick={() => {
                    dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false});
                    history.push('/certificados');
                  }}
                >
                  <span className='fa fa-certificate mr-1'></span> Atualizar Certificado
                </Button>
              ) : (
                <small className='text-muted'>Solicite ao administrador a atualização do certificado.</small>
              )}
            </>
          ) : /* Certificado A3 para NF-e ou CT-e - Mostrar aviso para usar Espião Monitor */
          enablePesquisar === true && parseInt(tipoCertificado) === 1 && tipoDocCons !== '2' && tipoDocCons !== '-1' ? (
            <>
              <div className='alert alert-warning mb-3'>
                <span className='mdi mdi-alert-circle mr-2'></span>
                <strong>Certificado A3 detectado!</strong>
                <p className='mb-0 mt-1'>
                  Para consultar documentos com certificado A3, utilize o <strong>Espião Monitor</strong>.
                </p>
              </div>
              <Button
                variant='primary'
                className='rounded tour-2'
                onClick={() => DownloadCloudMonitor()}
              >
                <span className='fa fa-download mr-1'></span> Download Espião Monitor
              </Button>
            </>
          ) : enablePesquisar === true && parseInt(tipoCertificado) === 0 ? (
            tipoDocCons > -1 ? (
              tipoDocCons === '1' && !possuiSaldo ? (
                <Button
                  variant={planoAtual === '5' ? 'warning' : 'primary'}
                  onClick={() => handleDirecionarLimiteCte()}
                  disabled={planoAtual === '5'}
                  className='rounded ml-5 tour-2'
                >
                  <span className='fa fa-wallet mr-1'></span> {planoAtual !== '5' ? 'Configurar limite de armazenamento CT-e' : 'Limite de armazenamento atingido'}
                </Button>
              ) : (
                <Button
                  variant='success'
                  onClick={() => handleEspionar()}
                  className='rounded ml-5 tour-2'
                  disabled={!enablePesquisar}
                >
                  <span className='fa fa-search mr-1'></span> Espionar documentos
                </Button>
              )
            ) : (
              <Button
                variant='warning'
                className='rounded ml-5 tour-2'
                disabled
              >
                <span className='fa fa-ban mr-1'></span> Selecione o tipo de documento
              </Button>
            )
          ) : (
            tipoDocCons === '2' && (
              <Button
                variant='success'
                onClick={() => handleEspionar()}
                className='rounded ml-5 tour-2'
                disabled={!enablePesquisar}
              >
                <span className='fa fa-search mr-1'></span> Espionar documentos
              </Button>
            )
          )}

          <Button
            variant='secondary'
            className='float-right'
            onClick={() => dispatch({type: ESPIONAR_SEFAZ, espionarSefaz: false})}
            disabled={espionando}
          >
            Fechar
          </Button>
        </div>

        {/* <Joyride
          callback={handleJoyrideCallback}
          run={run}
          styles={{
            options: {
              //arrowColor: '#e3ffeb',
              //backgroundColor: '#e3ffeb',
              //overlayColor: 'rgba(79, 26, 0, 0.4)',
              primaryColor: '#297bea',
              //textColor: '#004a14',
              //width: 900,
              zIndex: 10000,
            },
          }}
          continuous
          scrollToFirstStep
          showProgress
          showSkipButton
          disableOverlayClose
          steps={steps}
          // styles={{
          //   options: {
          //     zIndex: 10000,
          //   },
          // }}
        /> */}
      </Modal.Body>
    </Modal>
  );
};

export default ModalEspionar;
